export default {
  lang: {},
  list: [],
}
